import React, { useState, useEffect } from "react";
import { DiscussForm } from "parts/DiscussForm";
import Header from "parts/Header";
import Footer from "parts/Footer";
import { useSettings } from "lib/useSettings";

export const DiscussProjectPage = () => {
  const [data, setData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    projectIdea: "",
  });
  const { settings } = useSettings();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const onChange = (event) => {
    setData((prevData) => ({
      ...prevData,
      [event.target.name]: event.target.value,
    }));
  };

  const resetForm = () => {
    setData({
      name: "",
      company: "",
      email: "",
      phone: "",
      projectIdea: "",
    });
  };

  return (
    <>
      <Header />
      <div className="container mx-auto flex flex-col gap-10 px-4 pb-16 lg:flex-row lg:items-start lg:justify-center">
        <div className="flex-1">
          <DiscussForm data={data} onChange={onChange} resetForm={resetForm} />
        </div>
        <div className="mx-auto flex w-full max-w-sm flex-col gap-6 lg:mt-32">
          <div>
            <p className="mb-3 text-lg font-semibold text-maroon-800">Our Location</p>
            <iframe
              className="h-64 w-full rounded-2xl border border-slate-100 shadow-lg"
              title="VR Foods Location"
              src={settings.mapEmbedUrl}
              style={{ border: "0" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <div className="rounded-2xl border border-slate-100 bg-white p-6 shadow-md">
            <h2 className="mb-4 text-xl font-bold text-slate-800">Contact Information</h2>
            <dl className="space-y-2.5 text-sm text-slate-600">
              <div>
                <dt className="inline font-semibold">Address: </dt>
                <dd className="inline">{settings.address}</dd>
              </div>
              <div>
                <dt className="inline font-semibold">GSTIN/UIN: </dt>
                <dd className="inline">{settings.gstin}</dd>
              </div>
              <div>
                <dt className="inline font-semibold">PAN/IT No: </dt>
                <dd className="inline">{settings.pan}</dd>
              </div>
              <div>
                <dt className="inline font-semibold">State: </dt>
                <dd className="inline">{settings.state}</dd>
              </div>
              <div>
                <dt className="inline font-semibold">Place of Supply: </dt>
                <dd className="inline">{settings.placeOfSupply}</dd>
              </div>
              <div>
                <dt className="inline font-semibold">Contact: </dt>
                <dd className="inline">{settings.contactPhone}</dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
